import { useState } from 'react'

import { useVesselSearch } from '../api/hooks'
import { EntityLink } from '../components/EntityLink'
import { FilterBar } from '../components/FilterBar'
import { QueryState } from '../components/QueryState'
import { fmtText } from '../lib/format'

/**
 * Сколько строк отдаёт `/api/vessels` за раз. Предел ставит ЯДРО, фронт его не задаёт и
 * попросить другой не может: параметра у ручки нет. Здесь он записан один раз — иначе
 * число живёт и в условии «показывать ли оговорку», и словами в самой оговорке, и первый
 * же переезд предела в ядре оставляет их разными.
 */
const ПРЕДЕЛ_ВЫДАЧИ = 20

/** Суда = контакты Bitrix с LAST_NAME='Судно'; ядро отдаёт витрину vessels. */
export default function Vessels() {
  const [q, setQ] = useState('')
  const search = useVesselSearch(q)

  return (
    <>
      <div className="page-head">
        <h1>Суда</h1>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <FilterBar id="vessels">
          <div className="f" style={{ flex: 1, minWidth: 240 }}>
            <label htmlFor="vq">Название или IMO</label>
            <input id="vq" value={q} onChange={(e) => setQ(e.target.value)} placeholder="минимум 2 символа" autoFocus />
          </div>
        </FilterBar>
      </div>

      {q.trim().length < 2 ? (
        <div className="card muted">Введите минимум 2 символа — ядро ищет по названию и IMO.</div>
      ) : (
        <QueryState isLoading={search.isLoading} error={search.error}>
          <div className="card">
            {/* `cards` — на телефоне таблица разбирается на карточки (styles.css, §12). */}
            <div className="table-wrap cards">
              <table>
                <thead>
                  <tr>
                    <th className="nowrap">ID</th>
                    <th>Название</th>
                    <th className="nowrap">IMO</th>
                    <th className="nowrap">MMSI</th>
                    <th className="nowrap">Порт</th>
                  </tr>
                </thead>
                <tbody>
                  {(search.data ?? []).map((v) => (
                    <tr key={v.id}>
                      {/* id судна = id контакта-судна: карточка читает контакт по нему */}
                      <td className="mono nowrap" data-label="ID"><EntityLink kind="vessel" id={v.id} title={String(v.id)} /></td>
                      <td data-label="Название"><EntityLink kind="vessel" id={v.id} title={fmtText(v.name)} /></td>
                      <td className="mono nowrap" data-label="IMO">{fmtText(v.imo)}</td>
                      <td className="mono nowrap" data-label="MMSI">{fmtText(v.mmsi)}</td>
                      <td className="nowrap muted" data-label="Порт">{fmtText(v.port)}</td>
                    </tr>
                  ))}
                  {search.data && search.data.length === 0 && (
                    <tr>
                      <td colSpan={5} className="empty">
                        <div className="empty-title">Судно не найдено</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Число в подписи — длина САМОЙ выдачи, а не константа рядом: если ядро
                когда-нибудь отдаст другое количество, оговорка не соврёт. */}
            {search.data && search.data.length >= ПРЕДЕЛ_ВЫДАЧИ && (
              <div className="hint" style={{ marginTop: 10 }}>
                Показаны первые {search.data.length} — ядро ограничивает выдачу. Уточните запрос.
              </div>
            )}
          </div>
        </QueryState>
      )}
    </>
  )
}
